export default __webpack_public_path__ + "static/media/ic_match_48px.c4ddfb68.svg";